import cn from 'clsx'

// Components
import MiniCollectionList from 'components/sidebar/minicollectionlist'
import Menu, { Label } from 'components/sidebar/menu'
import IsAuthenticated from 'components/base/isauthenticated'
import YourLibrary from 'components/sidebar/yourlibrary'
import ErrorBoundary from 'errorboundary'

// Hooks
import { useAudio } from 'modules/audio/hooks'

import styles from './sidebar.css'

const Sidebar = () => {
  const { isPlaying } = useAudio()
  return (
    <div className={cn(styles.wrapper, isPlaying && styles.isPlaying)}>
      <div className={styles.top}>
        <Label>Our catalog</Label>
        <Menu />
        <IsAuthenticated>
          <Label>Your library</Label>
          <YourLibrary />
          <Label>Your collections</Label>
        </IsAuthenticated>
      </div>
      <IsAuthenticated>
        <ErrorBoundary>
          <MiniCollectionList className={styles.overflow} />
        </ErrorBoundary>
      </IsAuthenticated>
    </div>
  )
}

export default Sidebar
